import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'

// components
import { CButton, CImage } from '@coreui/react-pro'
import AppCard from '../../components/AppCard'
import AppTable from 'src/components/AppTable'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// icons
import AddMoreIconWhite from '../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

// helpers
import Axios from '../../helpers/axios'
import { columnCompanyTimeOffList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from '../../helpers/format-queries'
import useToastMessage from 'src/helpers/toast-message'

const CompanyTimeOffList = () => {
  const navigate = useNavigate()
  const { showSuccess, showError } = useToastMessage();

  const [isLoading, setIsLoading] = useState(false)
  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const [companyTimeOffList, setCompanyTimeOffList] = useState(null);
  const [companyTimeOffListCount, setCompanyTimeOffListCount] = useState(0);
  const [companyTimeOffListPerPage, setCompanyTimeOffListPerPage] = useState(10);
  const [activeCompanyTimeOffListPage, setActiveCompanyTimeOffListPage] = useState(1);
  const [searchCompanyTimeOffListFilter, setSearchCompanyTimeOffListFilter] = useState("");
  const [columnCompanyTimeOffListSorter, setColumnCompanyTimeOffListSorter] = useState({ column: "updatedAt", state: "desc" });

  useEffect(() => {
    let queries = {
      search: searchCompanyTimeOffListFilter,
      limit: companyTimeOffListPerPage,
      offset: companyTimeOffListPerPage * activeCompanyTimeOffListPage - companyTimeOffListPerPage,
      sort:
        (columnCompanyTimeOffListSorter &&
          `${columnCompanyTimeOffListSorter.column}%${columnCompanyTimeOffListSorter.state}`) ||
        "",
    };
    queries = formUrlQuery(queries);
    fetchAllCompanyTimeOffs(queries);
  }, [
    searchCompanyTimeOffListFilter,
    companyTimeOffListPerPage,
    activeCompanyTimeOffListPage,
    columnCompanyTimeOffListSorter,
  ]);

  const handleSearchItems = (search) => {
    setActiveCompanyTimeOffListPage(1)
    setSearchCompanyTimeOffListFilter(search);
  }

  const fetchAllCompanyTimeOffs = (queries) => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/company-time-off?${queries}`
    })
      .then(({ data }) => {
        let tempCompanyTimeOffList = data?.value
        tempCompanyTimeOffList = tempCompanyTimeOffList.map((item, index) => {
          return {
            ...item,
            updatedAt: moment(item?.updatedAt).format('YYYY-MM-DD'),
          }
        })
        setCompanyTimeOffList(tempCompanyTimeOffList);
        if (activeCompanyTimeOffListPage === 1) {
          setCompanyTimeOffListCount(data?.count);
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  };

  const handleDeleteConfirmation = () => {
    setIsLoading(true)
    Axios({
      method: "delete",
      url: `/api/tracker/v1/company-time-off/delete/${showConfirmDelete?.item?.id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setShowConfirmDelete({ show: false, item: {} })
          fetchAllCompanyTimeOffs()
          showSuccess('Company time off has been successfully deleted')
          window.location.reload()
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        setIsLoading(false)
      });
  }

  const handleOnRowClick = (item, columnName) => {
    if (columnName !== 'action') {
      navigate(`/company-time-off/details/${item.id}`)
    }
  }

  return (
    <>
      {
        showConfirmDelete?.show && (
          <AppModalConfirmation
            confirmationType='delete-item'
            itemName={`Company Time Off - ${showConfirmDelete?.item?.name}`}
            itemDetails={showConfirmDelete.item}
            itemType={showConfirmDelete.type}
            itemIndex={showConfirmDelete?.index}
            showModal={showConfirmDelete}
            setShowModal={setShowConfirmDelete}
            handleConfirmation={handleDeleteConfirmation}
            isLoading={isLoading}
          />
        )
      }
      <div className='d-grid gap-2 d-flex justify-content-end mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/company-time-off/add')}>
          <CImage fluid src={AddMoreIconWhite} className='me-2' />
          Add Company Time Off
        </CButton>
      </div>
      <AppCard
        className='mb-4'
        headerTitle={<h4>Company Time Off List</h4>}
        bodyContent={
          <AppTable
            companyTimeOffListPage
            tableFilter
            setShowConfirmDelete={setShowConfirmDelete}
            tableColumns={columnCompanyTimeOffList}
            tableContent={companyTimeOffList}
            contentPerPage={companyTimeOffListPerPage}
            activeContentPage={activeCompanyTimeOffListPage}
            contentCount={companyTimeOffListCount}
            searchContentFilter={searchCompanyTimeOffListFilter}
            setActiveContentPage={setActiveCompanyTimeOffListPage}
            setSearchContentFilter={handleSearchItems}
            setContentPerPage={setCompanyTimeOffListPerPage}
            setColumnContentSorter={setColumnCompanyTimeOffListSorter}
            handleOnRowClick={handleOnRowClick}
            isClickable={true}
          />
        }
      />
    </>
  )
}

export default CompanyTimeOffList
